<div class="advanced-errors">
  @for (error of errors; track error; let i = $index) {
    <span class="error" #mainErrorDiv>
      {{ error.message }}
    </span>
  }
</div>
